export const ACTION = {
	ADD_BRAND_TYPE: 'add_brand_type',
	ADD_ALL_BRANDS: 'add_all_brand',
	SET_TRANSLATIONS: 'set_translations',
	ADD_LACK: 'add_lack',
	ADD_ALL_LACKS: 'add_all_lacks',
};

export const addBrandType = (results) => {
	return {
		type: ACTION.ADD_BRAND_TYPE,
		payload: results,
	};
};
export const addAllBrands = (results) => {
	return {
		type: ACTION.ADD_ALL_BRANDS,
		payload: results,
	};
};
export const setTranslations = (results) => {
	return {
		type: ACTION.SET_TRANSLATIONS,
		payload: results,
	};
};
export const addLack = (results) => {
	return {
		type: ACTION.ADD_LACK,
		payload: results,
	};
};
export const addAllLacks = (results) => {
	return {
		type: ACTION.ADD_ALL_LACKS,
		payload: results,
	};
};
